import { z } from "zod";

import {
  createStaffSchema,
  publicStaffRoleEnumSchema,
  publicStaffStatusEnumSchema,
  rowStaffTypeSchema,
} from "@libs/schemas";
import { formatStaffRole, formatStaffStatus } from "@/utils/staff";

import { campusesRelationSchema } from "./campus";

export const staffSchema = rowStaffTypeSchema.merge(campusesRelationSchema);

export type StaffType = z.infer<typeof staffSchema>;

export type StaffRoleType = z.infer<typeof publicStaffRoleEnumSchema>;
export type StaffStatusType = z.infer<typeof publicStaffStatusEnumSchema>;

export const staffFormSchema = createStaffSchema;

export type StaffFormType = z.infer<typeof staffFormSchema>;

const staffFilterSchema = z.object({
  search: z.string().optional().catch(""),
  roles: z.array(publicStaffRoleEnumSchema).optional().catch([]),
  statuses: z.array(publicStaffStatusEnumSchema).optional().catch([]),
  campusesIds: z.array(z.string()).optional().catch([]),
});
export type StaffFilterType = z.infer<typeof staffFilterSchema>;

export const staffSearchParamsSchema = staffFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export const staffRolesOptions = publicStaffRoleEnumSchema.options.map(
  role => ({
    label: formatStaffRole(role),
    value: role,
  }),
);

export const staffStatusOptions = publicStaffStatusEnumSchema.options.map(
  status => ({
    label: formatStaffStatus(status),
    value: status,
  }),
);
